import { type RootState } from '../rmsStore';

export default function getAdvanceRuleEngineReducer(state: RootState) {
  return state.advanceRuleEngineReducer;
}